const FinalReportApi = (workId: string) => {
  return {
    FINAL_REPORT: `/driver/work/${workId}/snow_clearance/final_report`,
  };
};
export default FinalReportApi;
